<template>
  <div v-loading="loading" class="form-group-box">
    <div class="title">基本信息</div>
    <el-form
      :rules="rules"
      ref="form"
      :model="form"
      :validate-on-rule-change="false"
      label-position="left"
      label-width="127px"
      class="form-group"
    >
      <el-form-item label="任务类型">
        <el-radio-group v-model="taskMould">
          <el-radio :disabled="from !== 'create' || isRisk || isMilestone" label="任务">
            <div class="option-item option-blue">任务</div>
          </el-radio>
          <el-radio :disabled="from !== 'create' || isRisk || isMilestone" label="里程碑">
            <div class="option-item option-red">里程碑</div>
          </el-radio>
          <el-radio :disabled="from !== 'create' || isRisk || isMilestone" label="风险">
            <div class="option-item option-yellow">风险</div>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="任务模版" prop="typeId">
        <template slot="label">
          <span class="require-flag">*</span>
          任务模版
        </template>
        <el-select
          v-if="['create', 'copy'].includes(from)"
          v-model="form.typeId"
          placeholder="请选择任务模版"
          @change="selectTaskType"
          filterable
        >
          <el-option
            v-for="(taskType, index) in taskTypeList.data"
            :key="index"
            :label="taskType.label"
            :value="taskType.value"
          ></el-option>
        </el-select>
        <el-input
          v-else-if="from == 'edit'"
          :value="taskType.name"
          disabled
          class="color-main"
        ></el-input>
      </el-form-item>
      <el-form-item label="任务标题" prop="name">
        <template slot="label">
          <span class="require-flag">*</span>
          任务标题
        </template>
        <el-input
          v-model="form.name"
          placeholder="请填写"
          :disabled="isDisabled('name')"
        ></el-input>
      </el-form-item>
      <el-form-item label="负责人" prop="assignee">
        <user-selector
          v-model="form.assignee"
          :project-id="projectId"
          single-value-mode
          @change="changeAssignee"
          :disabled="isDisabled('assignee')"
        ></user-selector>
      </el-form-item>
      <el-form-item label="负责角色" prop="assigneeRole">
        <el-select
          v-model="form.assigneeRole"
          placeholder="请选择"
          @change="changeAssigneeRole"
          :disabled="isDisabled('assigneeRole')"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in roles"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="任务状态" prop="taskStatus">
        <el-input :value="taskStatus" disabled class="color-main"></el-input>
      </el-form-item>
      <el-form-item label="开始时间" prop="startAt">
        <el-date-picker
          v-model="form.startAt"
          type="date"
          placeholder="请选择"
          default-time="00:00:00"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="{ disabledDate: notInDuration }"
          :disabled="isDisabled('startAt')"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="截止时间" prop="dueDate">
        <el-date-picker
          v-model="form.dueDate"
          type="date"
          placeholder="请选择"
          default-time="00:00:00"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="{ disabledDate: notInDuration }"
          :disabled="isDisabled('dueDate')"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="任务分组" prop="groupId" v-if="isRisk || isMilestone">
        <el-select v-model="groupId" placeholder="请选择" @input="setGroupId">
          <el-option
            v-for="item in groupList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="任务分组" prop="groupId" v-else>
        <el-input :value="form.groupName" disabled class="color-main"></el-input>
      </el-form-item>
      <el-form-item label="父任务" prop="parentTask">
        <parent-field
          :parent="parentTask"
          :children="children"
          :project-id="projectId"
          :task-group="taskGroup"
          :task-id="taskId"
          @set-parent="setParent"
          :disabled="isDisabled('parentTask')"
        ></parent-field>
      </el-form-item>
      <el-form-item label="任务优先级" prop="priority" v-if="taskMould !== '风险'">
        <el-select v-model="form.priority" placeholder="请选择" :disabled="isDisabled('priority')">
          <el-option
            v-for="(level, index) in priorityLevel"
            :key="index"
            :label="level.label"
            :value="level.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="风险等级" prop="riskLevel" v-else>
        <el-select
          v-model="form.riskLevel"
          placeholder="请选择"
          class="sel-risk-level"
          :class="
            form.riskLevel == 1 ? 'blue_level' : form.riskLevel == 2 ? 'yellow_level' : 'red_level'
          "
        >
          <el-option label="低" :value="1">
            <el-tag
              size="small"
              color="#1989fa"
              :hit="false"
              style="color: white;border-radius: 6px"
            >
              低
            </el-tag>
          </el-option>
          <el-option label="中" :value="2">
            <el-tag
              size="small"
              color="#fda23f"
              :hit="false"
              style="color: white;border-radius: 6px"
            >
              中
            </el-tag>
          </el-option>
          <el-option label="高" :value="3">
            <el-tag
              size="small"
              color="#fd6565"
              :hit="false"
              style="color: white;border-radius: 6px"
            >
              高
            </el-tag>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="应对方案" v-if="taskMould === '风险'">
        <rich-input v-model="form.copingPlan"></rich-input>
      </el-form-item>
      <el-form-item label="任务附件" prop="attachments">
        <upload-file
          ref="upload-file"
          :disabled="isDisabled('attachments')"
          :oneFlag="false"
          @updateFiles="setAttachments"
        ></upload-file>
      </el-form-item>
      <el-form-item label="任务备注" prop="description">
        <rich-input v-model="form.description" :disabled="isDisabled('description')"></rich-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { priorityLevel } from "~/data/project"
import * as ProjectApi from "@/api/project/project"
import ParentField from "@/components/Task/EditDialog/ParentField"
import dj from "dayjs"
import RichInput from "@/components/FormControl/RichInput"
import UserSelector from "@/components/FormControl/UserSelector"
import { uploadingCounter } from "@/utils/uploadFile"
import UploadFile from "@/components/Sheet/SheetForm/FormItem/UploadFile"
import _ from "lodash"
import * as TaskApi from "@/api/project/task"

const isBetween = require("dayjs/plugin/isBetween")
dj.extend(isBetween)

export default {
  name: "task-form",
  components: { UploadFile, RichInput, ParentField, UserSelector },
  props: {
    from: String, // ["create", "edit",'milestone','risk']
    projectId: String,
    projectInfo: Object,
    parentTask: Object,
    taskGroup: {
      type: Object,
      required: true
    },
    curUserPermission: Object,
    isMilestone: {
      type: Boolean,
      default: false
    },
    isRisk: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const rules = {
      name: [
        {
          validator(rule, value, callBack) {
            if (!value) callBack("任务标题不能为空")
            callBack()
          },
          trigger: "blur"
        }
      ],
      dueDate: [
        {
          validator: (rule, value, callBack) => {
            if (this.form.startAt && dj(value).isBefore(this.form.startAt)) {
              callBack("任务截止时间不能早于开始时间")
            }
            callBack()
          },
          trigger: "change"
        }
      ]
    }
    return {
      priorityLevel,
      rules,
      loading: false,
      taskTypeList: {
        requested: false,
        data: []
      },
      taskStatus: "",
      taskType: "",
      form: {
        typeId: "",
        groupId: "",
        name: "",
        assignee: "",
        assigneeRole: "",
        startAt: "",
        dueDate: "",
        priority: "",
        description: "",
        copingPlan: "",
        riskLevel: null,
        attachmentIds: [],
        attachments: [],
        taskMould: ""
      },
      groupList: [],
      groupId: "",
      taskId: "",
      children: [],
      roles: [],
      members: [],
      taskMould: ""
    }
  },
  beforeCreate() {
    this.$options.components.DetailDialog = require("@/components/Task/DetailDialog").default
  },
  created() {
    // 获取所有角色
    ProjectApi.getAllProjectRole(this.projectId).then(
      roles => (this.roles = _.keyBy(roles, "id") || [])
    )
    // 获取所有成员
    ProjectApi.getProjectMembers(this.projectId).then(
      members => (this.members = _.keyBy(members, "userId") || [])
    )
    // 获取任务分组
    TaskApi.getTaskGroupList(this.projectId).then(groups => {
      this.groupList = groups.map(group => ({
        label: group.name,
        value: group.id
      }))
    })
  },
  methods: {
    init(taskInfo) {
      if (taskInfo?.riskSet || this.isRisk) this.taskMould = "风险"
      else if (taskInfo?.milestone || this.isMilestone) this.taskMould = "里程碑"
      else this.taskMould = "任务"
      this.form.groupId = this.taskGroup.id
      this.groupId = this.taskGroup.id
      this.form.groupName = this.taskGroup.name
      if (this.from === "create") {
        this.taskStatus = "待处理"
        this.form.priority = "0"
        this.loading = true
        this.getTaskTypeList().then(() => {
          this.form.typeId = this.taskTypeList.data[0].value
          this.loading = false
        })
      } else if (this.from === "edit") {
        this.taskId = taskInfo.id
        this.children = taskInfo.children
        this.taskType = taskInfo.taskType
        this.$emit("select-task-type", this.taskType)
        this.taskStatus = taskInfo.status
        this.initForm(taskInfo)
      } else if (this.from === "copy") {
        taskInfo.id = null
        taskInfo.children = null
        this.taskStatus = taskInfo.status = "待处理"
        Object.assign(this.form, {
          taskType: taskInfo.taskType,
          typeId: taskInfo.typeId
        })
        this.initForm(taskInfo)
        this.getTaskTypeList().then(() => {
          this.loading = false
        })
      }
      this.$refs["upload-file"].init(this.form.attachments)
      this.clearValidate()
    },
    resetData() {
      Object.assign(this.$data.form, this.$options.data().form)
    },
    initForm(taskInfo) {
      taskInfo.priority = taskInfo.priority ?? ""
      Object.assign(this.form, {
        name: taskInfo.name,
        priority: taskInfo.priority.toString(),
        assignee: taskInfo.assignee,
        assigneeRole: taskInfo.assigneeRole,
        startAt: taskInfo.startAt,
        dueDate: taskInfo.dueDate,
        description: taskInfo.description,
        attachments: taskInfo.attachments,
        attachmentIds: taskInfo.attachments.map(t => t.id),
        copingPlan: taskInfo.copingPlan,
        riskLevel: taskInfo.riskLevel === 0 ? null : taskInfo.riskLevel
      })
    },
    clearValidate() {
      this.$refs.form.clearValidate()
    },
    getTaskTypeList() {
      if (this.taskTypeList.requested) return Promise.resolve()
      return ProjectApi.getTaskTypeListByProject(this.projectId).then(res => {
        Object.assign(this.taskTypeList, {
          requested: true,
          data: res.map(i => {
            if (!i.taskType) return { label: "默认", value: "", data: i }
            else return { label: i.taskType.name, value: i.taskTypeId, data: i.taskType }
          })
        })
      })
    },
    notInDuration(date) {
      let earliestTime = this.projectInfo.startPeriod
      let latestTime = this.projectInfo.endPeriod
      if (this.parentTask?.startAt) {
        earliestTime = dj(earliestTime).isBefore(dj(this.parentTask.startAt))
          ? this.parentTask.startAt
          : earliestTime
      }
      if (this.parentTask?.dueDate) {
        latestTime = dj(latestTime).isAfter(dj(this.parentTask.dueDate))
          ? this.parentTask.dueDate
          : latestTime
      }
      return !dj(date).isBetween(earliestTime, latestTime, null, "[]")
    },
    selectTaskType(val) {
      let taskType = this.taskTypeList.data.find(i => i.value == val).data
      // 设置任务标题默认值
      if (!this.form.name) {
        this.form.name = taskType.name
      }
      this.$emit("select-task-type", taskType)
    },
    setGroupId(val) {
      this.form.groupId = val
      this.form.groupName = this.groupList.find(group => group.value === val).label
    },
    setParent(parent) {
      this.$emit("set-parent", parent)
    },
    setAttachments(val) {
      this.form.attachmentIds = val.map(item => item.id)
    },
    changeAssigneeRole() {
      // 当负责角色不为空、负责人为空，则选负责角色中的主负责人为该任务的负责人
      if (this.form.assigneeRole && !this.form.assignee) {
        this.form.assignee = this.roles[this.form.assigneeRole]?.mainAssignee
      }
    },
    changeAssignee() {
      // 当负责人不为空，且该成员有主负责人角色，则显示这个角色
      if (this.form.assignee) {
        this.members[this.form.assignee].projectRoles.map(r => {
          if (r?.mainAssignee === this.form.assignee) {
            this.form.assigneeRole = r.id
          }
        })
      }
    },
    output() {
      return new Promise((resolve, reject) => {
        if (uploadingCounter > 0) {
          resolve({ result: false })
          this.$message.error("当前还有文件未上传完成,请等待上传完成后重试")
          return
        }
        this.form.taskMould =
          this.taskMould === "风险" ? "risk" : this.taskMould === "里程碑" ? "milestone" : "task"
        this.$refs.form.validate(valid => {
          if (!valid) resolve({ result: false })
          resolve({ result: true, form: this.form })
        })
      })
    },
    isDisabled(field) {
      let priMap = {
        name: "UPDATE_NAME",
        assignee: "UPDATE_ASSIGNEE",
        assigneeRole: "UPDATE_ASSIGNEE_ROLE",
        startAt: "UPDATE_START_AT",
        dueDate: "UPDATE_DUE_DATE",
        parentTask: "UPDATE_PARENT_ID",
        priority: "UPDATE_PRIORITY",
        description: "UPDATE_DESCRIPTION",
        attachments: "UPDATE_ATTACHMENT",
        subTask: "UPDATE_SUB_TASK"
      }
      return this.from === "edit" && !this.curUserPermission[priMap[field]]
    }
  }
}
</script>

<style lang="scss" scoped>
.form-group-box {
  .title {
    position: relative;
    margin-bottom: 20px;
    color: $color-font-first;
    font-size: $font-size-title-topic;
    line-height: 28px;
    &::before {
      content: "";
      position: absolute;
      left: -22px;
      width: 6px;
      height: 28px;
      border-radius: 4px;
      background-color: $color-main;
    }
  }
  .form-group {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    .el-form-item {
      position: relative;
      margin-bottom: 8px;
      font-size: 14px;
      // height: 32px;
      // line-height: 30px;
      &:nth-child(odd) {
        width: 51%;
      }
      &:nth-child(even) {
        width: 49%;
        box-sizing: border-box;
      }
      .require-flag {
        color: red;
        font-size: 24px;
        padding-right: 4px;
        padding-top: 10px;
      }
      .icon-tip {
        margin-left: 4px;
        font-size: 16px;
        &:hover {
          color: #3aacf8;
        }
      }
      .parent-task {
        color: $color-main;
        cursor: pointer;
      }
      ::v-deep {
        .el-form-item__label {
          min-height: 40px;
          display: flex;
          align-items: center;
          line-height: 18px;
          padding: 0;
          padding-right: 12px;
        }
        .el-form-item__content {
          width: 320px;
          .el-date-editor,
          .el-select {
            width: 100%;
          }
        }
        .el-form-item__error {
          position: relative;
        }
        .color-main .el-input__inner {
          color: $color-font-first;
        }
      }
    }
  }
  ::v-deep {
    .option-item {
      border-radius: 6px;
      padding: 1.5px 5px;
      color: white;
      white-space: normal;
      line-height: 17px;
      display: inline-flex;
      word-break: break-all;
    }

    .option-blue {
      background-color: #1989fa !important;
    }

    .option-yellow {
      background-color: #fda23f !important;
    }

    .option-red {
      background-color: #fd6565 !important;
    }
  }
}
</style>
